import { render, staticRenderFns } from "./home_button.vue?vue&type=template&id=f73aaaea&"
import script from "./home_button.vue?vue&type=script&lang=js&"
export * from "./home_button.vue?vue&type=script&lang=js&"
import style0 from "./home_button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports